import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { trackEvent } from '../../utils/analytics';
import { GOLD, mono } from './tokens';

const NON_PUBLIC_ROUTE_PATTERNS = [
  /^\/admin(?:\/|$)/i,
  /^\/manager(?:\/|$)/i,
  /^\/dashboard(?:\/|$)/i,
  /^\/settings(?:\/|$)/i,
  /^\/profile(?:\/|$)/i,
  /^\/my-bookings(?:\/|$)/i,
  // Hiring funnel is for driver candidates, not parking customers — the
  // Manage Booking CTA is irrelevant on /hiring/apply (email-driven redirect),
  // /hiring/otr, /hiring/box-truck, /hiring/oversize, /hiring/amazon-relay,
  // and the /hiring marketplace itself.
  /^\/hiring(?:\/|$)/i,
];

const INLINE_BOOKING_ACCESS_ROUTE_PATTERNS = [
  /^\/$/,
  /^\/list-your-lot(?:\/|$)/i,
  /^\/request-parking(?:\/|$)/i,
];

export default function FloatingManageBooking() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < 768,
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    const footer = document.getElementById('yard-footer');
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0.1 },
    );

    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  if (location.pathname === '/manage-booking') return null;
  if (NON_PUBLIC_ROUTE_PATTERNS.some((pattern) => pattern.test(location.pathname))) return null;
  if (INLINE_BOOKING_ACCESS_ROUTE_PATTERNS.some((pattern) => pattern.test(location.pathname))) return null;

  const positionStyle = isMobile
    ? { bottom: 16, left: '50%', transform: visible ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(12px)' }
    : { bottom: 28, right: 28, transform: visible ? 'translateY(0)' : 'translateY(12px)' };

  return (
    <Link
      to="/manage-booking"
      className="yard-floating-manage-booking"
      onClick={() => trackEvent('nav_click', { source: 'floating_manage_booking', path: location.pathname })}
      style={{
        position: 'fixed',
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '10px 18px',
        background: '#0A0A0A',
        border: `1px solid ${GOLD}`,
        borderRadius: 999,
        fontFamily: mono,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '.08em',
        color: GOLD,
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        boxShadow: '0 4px 24px rgba(184,134,11,.25)',
        opacity: visible ? 1 : 0,
        transition: 'opacity 220ms ease, transform 220ms ease',
        pointerEvents: visible ? 'auto' : 'none',
        ...positionStyle,
      }}
    >
      Manage Booking →
    </Link>
  );
}
